import { createGlobalStyle } from 'themed-components';

export const GlobalStyle = createGlobalStyle`
body {
  margin: 0;
  font-family: ${({ theme }) => theme.globals.body.font.family};
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background-color: ${({ theme }) => theme.globals.body.colors.background};
}

code {
  font-family: ${({ theme }) => theme.globals.code.font.family};
}
`;
